module.exports = __webpack_public_path__ + "img/subs-dairy.59c19bf3.png";